module.exports = __webpack_public_path__ + "img/mobile-screen.ece3671f.svg";